import { AppFunctionComponent } from "../../../types"
import React, { useState } from "react"
import { groupByKey } from "../../helpers/group-by-key"
import { SubnavigationItem } from "../../types/menu.interface"
import {
  Category,
  SubMenuContainer,
  SubMenuLink,
  SubmenuWrapper,
} from "./subnavigation-list.styled"

interface Props {
  links: SubnavigationItem[]
  title: string
}

interface GroupedArray {
  groupName: string
  items: SubnavigationItem[]
}

const SubnavigationList: AppFunctionComponent<Props> = ({
  className = "",
  links,
  title,
}) => {
  const [itemsHovered, setItemsHovered] = useState(false)

  const dimItems = () => {
    setItemsHovered(true)
  }

  const showItems = () => {
    setItemsHovered(false)
  }

  const groupedByCategory = groupByKey(
    links,
    (group: SubnavigationItem) => group.category || ""
  ) as GroupedArray[]

  return (
    <SubMenuContainer
      data-testid={"submenu"}
      className={className}
      hovered={itemsHovered}
      aria-label={title}
    >
      {groupedByCategory.map((group: GroupedArray, index: number) => (
        <SubmenuWrapper key={index} active={Boolean(group.groupName)}>
          {group.groupName && <Category>{group.groupName}</Category>}
          {group.items &&
            group.items.map((link: SubnavigationItem) => (
              <SubMenuLink
                key={link.path}
                to={link.path}
                activeClassName={"active"}
                partiallyActive
                onMouseEnter={dimItems}
                onMouseLeave={showItems}
              >
                {link.displayName}
              </SubMenuLink>
            ))}
        </SubmenuWrapper>
      ))}
    </SubMenuContainer>
  )
}

export default SubnavigationList
